import { render } from "./SimpleReaction.vue?vue&type=template&id=53b10ad0&ts=true"
import script from "./SimpleReaction.vue?vue&type=script&lang=ts"
export * from "./SimpleReaction.vue?vue&type=script&lang=ts"

import "./SimpleReaction.vue?vue&type=style&index=0&id=53b10ad0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__